"use strict";
exports.__esModule = true;
var version = "1.6.0";
exports["default"] = version;
